const documentStatus = [
  { id: 'A', name: 'Active' },
  { id: 'P', name: 'Pending' },
  { id: 'S', name: 'Suspended' }
];
const documentFilterStatus = [
  { id: 'ACTIVE', name: 'Active' },
  { id: 'PENDING', name: 'Pending' },
  { id: 'SUSPENDED', name: 'Suspended' }
];

const documentReviewStatusFilter = [
  { id: 'reviewed', name: 'Reviewed' },
  { id: 'unreviewed', name: 'Not reviewed' }
];

const matchingStatus = [
  { id: 'MATCHED', name: 'Matched' },
  { id: 'MANUALLY_SELECTED', name: 'Manually Selected' },
  { id: 'MISMATCH', name: 'Mismatch' },
  { id: 'MATCH_NOT_IN_FUND', name: 'Match Not In Fund' },
  { id: 'INACTIVE_INVESTOR', name: 'Inactive Investor' },
  { id: 'MULTIPLE_INVESTORS', name: 'Multiple Investors' },
  { id: 'MULTIPLE_FUNDS', name: 'Multiple Funds' }
];

const batchTitleVariables = [
  { label: 'Investor Id', value: '!investorid' },
  { label: 'Investor Name', value: '!investorname' },
  { label: 'Fund Id', value: '!fundid' },
  { label: 'Fund Name', value: '!fundname' },
  { label: 'Fund family', value: '!fundfamily' },
  { label: 'Year', value: '!year' },
  { label: 'Quarter', value: '!quarter' },
  { label: 'Quarter (Qq)', value: '!quarter(Qq)' },
  {
    label: 'Document Date',
    value: '!docdate',
    values: [
      { label: 'docdate(M.d.yyyy)', value: '!docdate(M.d.yyyy)' },
      { label: 'docdate(MM/dd/yyyy)', value: '!docdate(MM/dd/yyyy)' },
      { label: 'docdate(MM/dd/yy)', value: '!docdate(MM/dd/yy)' },
      { label: 'docdate(dd/MM/yyyy)', value: '!docdate(dd/MM/yyyy)' },
      { label: 'docdate(yyyy-MM-dd)', value: '!docdate(yyyy-MM-dd)' },
      { label: 'docdate(MM-dd-yy)', value: '!docdate(MM-dd-yy)' },
      { label: 'docdate(dd-MM-yy)', value: '!docdate(dd-MM-yy)' },
      { label: 'docdate(MM-dd-yyyy)', value: '!docdate(MM-dd-yyyy)' },
      { label: 'docdate(yyyy/MM/dd)', value: '!docdate(yyyy/MM/dd)' },
      { label: 'docdate(yyyy/dd/MM)', value: '!docdate(yyyy/dd/MM)' },
      { label: 'docdate(yyyy-dd-MM)', value: '!docdate(yyyy-dd-MM)' },
      { label: 'docdate(MMMM-d-yyyy)', value: '!docdate(MMMM-d-yyyy)' },
      { label: 'docdate(MMMM d,yyyy)', value: '!docdate(MMMM d,yyyy)' },
      { label: 'docdate(MMMM d, yyyy)', value: '!docdate(MMMM d, yyyy)' },
      { label: 'docdate(MMMM/d/yyyy)', value: '!docdate(MMMM/d/yyyy)' },
      { label: 'docdate(MM d,yyyy)', value: '!docdate(MM d,yyyy)' },
      { label: 'docdate(MM d, yyyy)', value: '!docdate(MM d, yyyy)' },
      { label: 'docdate(MM.dd.yy)', value: '!docdate(MM.dd.yy)' },
      { label: 'docdate(MM dd,yyyy)', value: '!docdate(MM dd,yyyy)' },
      { label: 'docdate(MM dd, yyyy)', value: '!docdate(MM dd, yyyy)' },
      { label: 'docdate(MM/dd/yyyy)', value: '!docdate(MM/dd/yyyy)' },
      { label: 'docdate(dd MMMM yyyy)', value: '!docdate(dd MMMM yyyy)' }
    ]
  },
  {
    label: 'Document Due Date',
    value: '!duedate',
    values: [
      { label: 'duedate(M.d.yyyy)', value: '!duedate(M.d.yyyy)' },
      { label: 'duedate(MM/dd/yyyy)', value: '!duedate(MM/dd/yyyy)' },
      { label: 'duedate(MM/dd/yy)', value: '!duedate(MM/dd/yy)' },
      { label: 'duedate(dd/MM/yyyy)', value: '!duedate(dd/MM/yyyy)' },
      { label: 'duedate(yyyy-MM-dd)', value: '!duedate(yyyy-MM-dd)' },
      { label: 'duedate(MM-dd-yy)', value: '!duedate(MM-dd-yy)' },
      { label: 'duedate(dd-MM-yy)', value: '!duedate(dd-MM-yy)' },
      { label: 'duedate(MM-dd-yyyy)', value: '!duedate(MM-dd-yyyy)' },
      { label: 'duedate(yyyy/MM/dd)', value: '!duedate(yyyy/MM/dd)' },
      { label: 'duedate(yyyy/dd/MM)', value: '!duedate(yyyy/dd/MM)' },
      { label: 'duedate(yyyy-dd-MM)', value: '!duedate(yyyy-dd-MM)' },
      { label: 'duedate(MMMM-d-yyyy)', value: '!duedate(MMMM-d-yyyy)' },
      { label: 'duedate(MMMM d,yyyy)', value: '!duedate(MMMM d,yyyy)' },
      { label: 'duedate(MMMM d, yyyy)', value: '!duedate(MMMM d, yyyy)' },
      { label: 'duedate(MMMM/d/yyyy)', value: '!duedate(MMMM/d/yyyy)' },
      { label: 'duedate(MM d,yyyy)', value: '!duedate(MM d,yyyy)' },
      { label: 'duedate(MM d, yyyy)', value: '!duedate(MM d, yyyy)' },
      { label: 'duedate(MM.dd.yy)', value: '!duedate(MM.dd.yy)' },
      { label: 'duedate(MM dd,yyyy)', value: '!duedate(MM dd,yyyy)' },
      { label: 'duedate(MM dd, yyyy)', value: '!duedate(MM dd, yyyy)' },
      { label: 'duedate(MM/dd/yyyy)', value: '!duedate(MM/dd/yyyy)' },
      { label: 'duedate(dd MMMM yyyy)', value: '!duedate(dd MMMM yyyy)' }
    ]
  }
];

export {
  documentStatus,
  matchingStatus,
  documentFilterStatus,
  batchTitleVariables,
  documentReviewStatusFilter
};
